var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / upload-cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5457 10.5463L7.9994 8.00004L5.45312 10.5463",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 8.00004V13.7292",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3406 12.0677C13.9615 11.7292 14.4519 11.1936 14.7346 10.5454C15.0173 9.89725 15.076 9.17338 14.9016 8.48809C14.7272 7.8028 14.3295 7.1951 13.7713 6.76092C13.2132 6.32674 12.5263 6.0908 11.8192 6.09033H11.0171C10.8244 5.34506 10.4653 4.65317 9.96675 4.06668C9.46819 3.48018 8.84315 3.01434 8.13863 2.70417C7.43411 2.39401 6.66844 2.24759 5.89919 2.27594C5.12994 2.30428 4.37712 2.50664 3.69733 2.86781C3.01755 3.22897 2.42848 3.73955 1.97443 4.36114C1.52037 4.98274 1.21313 5.69918 1.07582 6.45661C0.938505 7.21404 0.974685 7.99274 1.18164 8.73417C1.38859 9.4756 1.76093 10.1605 2.27067 10.7373",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.5457 10.5463L7.9994 8.00004L5.45312 10.5463",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudIcon);
export default __webpack_public_path__ + "static/media/upload_cloud_icon.c6af23816b0feefc1694e74b5bbd36e5.svg";
export { ForwardRef as ReactComponent };